// BCM-898 · Goods Receipt Dashboard — inline tab strip used by PA4/PA6.
// A row of tabs (each with an optional count badge) on the left half, action buttons
// on the right half (Sync Inventory / Sync PO / Resubmit Document) — see TabsBar —
// then the active tab body.
// Matches the mockups (slides 11, 13, 15). Default-selects the first tab.
// onActiveChange (optional) — reports the active tab's key to the parent
// whenever it changes. Used by PA6 so its shared Approve button (rendered
// below every stacked section, not inside any one of them) can hide itself
// while a "View Document"-style tab is open — approving doesn't apply while
// reviewing the underlying document.
import React, { useEffect, useState } from "react";
import { useGRStyles } from "../../goodsReceiptStyles";
import TabsBar from "./TabsBar";

const ActionTabs = ({ tabs, headRight, onActiveChange }) => {
  const classes = useGRStyles();
  const list = (tabs || []).filter(Boolean);
  const [active, setActive] = useState(0);
  const idx = Math.min(active, Math.max(list.length - 1, 0));
  const current = list[idx];

  useEffect(() => {
    if (onActiveChange) onActiveChange(current ? current.key : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current && current.key]);

  if (list.length === 0) return null;
  return (
    <div>
      <TabsBar headRight={headRight}>
        {list.map((t, i) => (
          <div
            key={t.key}
            className={`${classes.tab} ${i === idx ? classes.tabActive : ""}`}
            onClick={() => setActive(i)}
            role="tab"
            aria-selected={i === idx}
            tabIndex={0}
          >
            {t.label}
            {t.badge != null && t.badge !== "" && (
              <span className={classes.tabBadge}>{t.badge}</span>
            )}
          </div>
        ))}
      </TabsBar>
      <div>{current.render()}</div>
    </div>
  );
};

export default ActionTabs;
